import React, { useEffect, useState } from 'react'
import { Input } from '@st-operations/uikit/src/v2'

import { getDestinations } from '_services/destinations'

import CustomSelect from '_components/custom-select'
import CustomCheckbox from '_components/custom-checkbox'

const FORMAT_OPTIONS = [
  {
    value: 'csv',
    label: 'CSV',
  },
  {
    value: 'tsv',
    label: 'TSV',
  },
  {
    value: 'json',
    label: 'JSON',
  },
  {
    value: 'parquet',
    label: 'Parquet',
  },
]

export default function FirstPartyForm({ data = {}, idTypeOptions, disabled, onDataChange }) {
  const [destinations, setDestinations] = useState([])

  useEffect(function fillDestinationOptions() {
    async function fetchData() {
      try {
        const destinationsResponse = await getDestinations({
          fields: ['_id', 'api_integration', 'name', 'slug'],
          limit: 1000,
        })

        setDestinations(destinationsResponse.items.sort((a, b) => (a.name > b.name ? 1 : -1)))
      } catch (error) {
        toast.error(error.message)
      }
    }
    fetchData()
  }, [])

  return (
    <div>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1 relative">
          <CustomSelect
            label="Destination"
            isSearchable
            options={destinations}
            value={destinations.find((destination) => destination.slug === data.destinationId)}
            onChange={(destination) => {
              onDataChange({ ...data, destinationId: destination?.slug })
            }}
          />
          <div className="flex flex-row items-center justify-center gap-2 absolute right-0 -top-1 text-[14px] font-semibold text-gray-700">
            <CustomCheckbox
              className=""
              label="Is One Time"
              checked={data.isOnetime}
              onChange={(e) => onDataChange?.({ ...data, isOnetime: e.target.checked })}
              disabled={disabled}
            />
          </div>
        </div>
        <CustomSelect
          className="m-0"
          label="Format"
          disabled={disabled}
          options={FORMAT_OPTIONS}
          value={FORMAT_OPTIONS.find((option) => option.value === data.format)}
          onChange={({ value }) => onDataChange?.({ ...data, format: value })}
        />
        <If condition={data.format === 'csv' || data.format === 'tsv'}>
          <CustomCheckbox
            checked={data.hasHeader}
            label="Has Header"
            disabled={disabled}
            onChange={(e) => onDataChange?.({ ...data, hasHeader: e.target.checked })}
          />
        </If>
        <If condition={data.format === 'csv'}>
          <Input
            className="m-0"
            label="Delimiter"
            disabled={disabled}
            value={data.delimiter || ''}
            onChange={(value) => {
              onDataChange?.({ ...data, delimiter: value })
            }}
          />
        </If>
        <CustomSelect
          className="m-0"
          label="Primary Key"
          disabled={disabled}
          options={idTypeOptions}
          value={idTypeOptions?.find((option) => option === data.idType)}
          onChange={({ value }) => {
            onDataChange?.({ ...data, idType: value })
          }}
        />
      </div>
    </div>
  )
}
